import React from "react";

import { useTheme } from '@mui/material/styles';

function DashboardIcon({ color: customColor, isActive }) {
    const theme = useTheme();

    const color = isActive ? theme.palette.primary.contrastText : (customColor || theme.palette.icons.color);

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" className="valign-middle">
            <rect stroke={color} width={7} height={7} x={3} y={3} strokeWidth={2} rx={1} />
            <rect stroke={color} width={7} height={7} x={3} y={14} strokeWidth={2} rx={3.5} />
            <path stroke={color} strokeWidth={2} d="M14 6.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0Z" />
            <rect stroke={color} width={7} height={7} x={14} y={14} strokeWidth={2} rx={1} />
        </svg>
    );
}

export default DashboardIcon;
